namespace TabAurous.Retail {
    export interface GiftVoucherItemsForm {
        GiftMasterId: Serenity.LookupEditor;
        Quantity: Serenity.IntegerEditor;
        ItemDetails: GiftVoucherItemDetailsEditor;
    }

    export class GiftVoucherItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.GiftVoucherItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GiftVoucherItemsForm.init)  {
                GiftVoucherItemsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.IntegerEditor;
                var w2 = GiftVoucherItemDetailsEditor;

                Q.initFormType(GiftVoucherItemsForm, [
                    'GiftMasterId', w0,
                    'Quantity', w1,
                    'ItemDetails', w2
                ]);
            }
        }
    }
}
